import React from 'react';
import { Box, Text } from 'components';
import { EditCircleIcon } from 'components/Icons';
import { AvatarImageContainer, AvatarContainer, EditOverlay, AvatarImagePicture } from './Styles';

type Props = {
  src?: string | null;
  alt?: string | null;
  size?: string;
  xsSize?: string;
  hover?: boolean;
  editIcon?: boolean;
  hidden?: boolean;
  name?: string;
  onClick?: () => void;
};

function AvatarImage({
  src,
  alt = '',
  size = '12rem',
  xsSize,
  hover = false,
  editIcon = false,
  hidden = typeof window !== 'undefined',
  name,
  onClick,
}: Props) {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <AvatarContainer
      size={size}
      hover={hover}
      onClick={onClick}
      {...(xsSize ? { 'xs-size': xsSize } : {})}
      {...(onClick ? {
        role: 'button',
        tabIndex: 0,
        onKeyDown: handleKeyDown,
      } : {})}
    >
      <AvatarImageContainer size={size} {...(xsSize ? { 'xs-size': xsSize } : {})}>
        {src && (
          <AvatarImagePicture
            suppressHydrationWarning
            src={src}
            alt={alt}
            hidden={hidden}
            onLoad={(event: React.SyntheticEvent<HTMLImageElement>) => {
              event.currentTarget.style.opacity = '1';
            }}
          />
        )}
        {editIcon && (
          <EditOverlay>
            <EditCircleIcon />
          </EditOverlay>
        )}
      </AvatarImageContainer>

      {name && (
        <Box mt="large" fullWidth>
          <Text
            fontSize="medium"
            display="block"
            align="center"
            ellipsis="true"
            bold
          >
            {name}
          </Text>
        </Box>
      )}
    </AvatarContainer>
  );
}

export default React.memo(AvatarImage);


